import axios from 'axios'
import  { getTokenInCookie } from './index'
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'

const http = axios.create({
    timeout: 1000 * 120,
    withCredentials: false,
    headers: {
      'Content-Type': 'application/json; charset=utf-8'
    }
})
const baseUrl = process.env.NODE_ENV == 'production' ? 'https://oaapi.univ-bio.com/' : 'https://oaapit.univ-bio.com/'
// request interceptor
http.interceptors.request.use(
    config => {
      // Do something before request is sent
      var token = getTokenInCookie();
      if (!!token) {
        // 让每个请求携带token-- ['X-Token']为自定义key 请根据实际情况自行修改
          config.headers['token'] = token
      }
      return config
    },
    /**
     * 下面的注释为通过在response里，自定义code来标示请求状态
     * 当code返回如下情况则说明权限有问题，登出并返回到登录页
     * 如想通过 xmlhttprequest 来状态码标识 逻辑可写在下面error中
     * 以下代码均为样例，请结合自生需求加以修改，若不需要，则可删除
     */
    error => {
      // Do something with request error
      Promise.reject(error)
    }
  )
    /**
     * 请求地址处理
     * @param {*} actionName action方法名称
     */
http.adornUrl = (actionName) => {
    // 非生产环境 && 开启代理, 接口前缀统一使用[/proxyApi/]前缀做代理拦截!
    return baseUrl + actionName
}

export default http


// WEBPACK FOOTER //
// ./src/utils/httpRequest.js